<template>
	<div>
		<b-row class="print-row mt-3">
			<b-col>
				<h4 class="avoid-page-break-after">Feats</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(levelData, level) in previousLevels" :key="'details-abilities-feats-level-'+level">
			<b-col v-if="levelData.Feats.length > 0">
				<h5 class="avoid-page-break-after">{{level|ordinal}} Level</h5>
				<b-row class="print-row mt-3" v-for="(feat, featID) in levelData.Feats" :key="'details-abilities-feats-level-'+level+'-feat-'+featID">
					<b-col cols="2">
						<strong>{{feat.Name}}</strong>
					</b-col>
					<b-col cols="10" class="pre">
						{{feat.Description}}
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		previousLevels: function(){
			return this.$store.getters.previousLevels
		}
	}
}
</script>

<style scoped>

</style>